module.exports = __webpack_public_path__ + "img/img-3-7.2173a50a.png";